export const calculatePolicyPercentage = (
  vehicles?: number,
  vehiclesOnPolicy?: number
): number => {
  if (!vehiclesOnPolicy || !vehicles) {
    return 0
  }
  return Math.round((vehicles / vehiclesOnPolicy) * 100)
}
